export default "__VITE_ASSET__BCdeNSa1__"